import { Box, Paper, useTheme } from "@mui/material";
import * as Sentry from "@sentry/react";
import { Route, Switch } from "react-router-dom";
import useErrorBoundary from "use-error-boundary";

import { FeatureFlagged } from "@/Components/FeatureFlagging";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

import ApiContextProvider from "./api/context/ApiContextProvider";
import { ChatHistoryNavbar } from "./ChatHistoryBar";
import { ChatPage } from "./ChatPage";
import ChatContextProvider from "./context/ChatContextProvider";
import { EmptyChatPage } from "./EmptyChatPage";
import ThemeProvider from "./theme/ThemeProvider";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  return (
    <Paper sx={{ display: "flex", height: "100vh" }}>
      <FeatureFlagged featureName="maiteChatHistory">
        <ChatHistoryNavbar
          sx={{
            boxShadow: "4px 0px 4px -4px #00000040",
            borderRight: theme.palette.mode === "dark" ? "1px solid #4B4B4B" : undefined,
          }}
        />
      </FeatureFlagged>
      <Box sx={{ flexGrow: 1, overflow: "auto" }}>{children}</Box>
    </Paper>
  );
};

export const HendrenRouter = () => {
  const { theme } = useInfo();

  const { ErrorBoundary, didCatch } = useErrorBoundary({
    onDidCatch(error, errorInfo) {
      console.error("maite-ui error", error, errorInfo);
      Sentry.captureException(error);
    },
  });

  if (didCatch) {
    return <div></div>;
  }

  return (
    <ErrorBoundary>
      <ApiContextProvider>
        <ThemeProvider paletteMode={theme.mode}>
          <ChatContextProvider>
            <Switch>
              <Route exact path="/maite">
                <Layout>
                  <EmptyChatPage />
                </Layout>
              </Route>
              <Route path="/maite/:chatId">
                <Layout>
                  <ChatPage />
                </Layout>
              </Route>
            </Switch>
          </ChatContextProvider>
        </ThemeProvider>
      </ApiContextProvider>
    </ErrorBoundary>
  );
};
